import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import { mstrace } from '@ms/utils/trace'
import DialogSignup from './DialogSignup.vue'
import { isApp } from 'wap/hybrid/device'
import { gotoAppSignup } from 'wap/hybrid'

const DialogSignupConstructor = Vue.extend(DialogSignup)
let insSignup = null

export const openSignup = () => {
  // 针对静态打包的 app WebView 使用原生注册
  if (process.env.PLATFORM === 'local' && isApp()) {
    return gotoAppSignup()
  }

  if (!insSignup) {
    insSignup = new DialogSignupConstructor({ i18n })
    insSignup.$mount()
    document.querySelector('body').appendChild(insSignup.$el)
    insSignup.open()
  } else {
    insSignup.open()
  }
  mstrace('registerpage')
}
